export function mapTransactionType(transactionType : string): string {
    switch(transactionType) {
        case "DRS_DECON_RECEIPT":
        case "DC_DELIVERY_RECEIPT":
        case "DC_GOODS_HOLDER_RECEIPT": {
            return "Goods Receipt"
        }
        case "DRS_SHIPMENT_REMOVAL": 
        case "DC_DELIVERY_REMOVAL": {
            return "Goods Removal"
        }
        case "WAREHOUSE_ENTRY": {
            return "Goods Entry"
        }
        case "CUSTOMS_ADJUSTMENT_POSITIVE":
        case "NODE_ADJUSTMENT_POSITIVE":  {
            return "Goods Entry";
        }
        case "CUSTOMS_ADJUSTMENT_NEGATIVE":
        case "NODE_ADJUSTMENT_NEGATIVE":  {
            return "Goods Removal";
        }
        case "NODE_ADJUSTMENT_UPDATE":  {
            return "Update Adjustment";
        }
        case "NODE_ADJUSTMENT":  {
            return "Adjustment";
        }
        case "DIVERT_SHIPMENT_SHIPPED": {
            return "Divert shipped";
        }
        case "CUSTOMS_CLEAR_TO_NONBONDED": {
            return "Ledger Update";
        }
        case "MIGRATION": {
            return "Migration";
        }
        default: {
            return "Undefined " + transactionType
        }
    }
}
